import React from 'react';

// value/onChange work with a single string: 'spot' or 'day'
const GroupByPicker = ({ value = 'spot', onChange, label = "Group By" }) => {
    const options = [
        { label: 'By Spot', value: 'spot' },
        { label: 'By Day', value: 'day' },
    ];

    return (
        <div>
            <label className="block text-sm font-medium text-custom-light-grey mb-3">
                {label}
            </label>

            <div className="flex rounded-lg bg-custom-dark/30 divide-x divide-custom-charcoal overflow-hidden">
                {options.map((option) => {
                    const isSelected = value === option.value;

                    return (
                        <button
                            key={option.value}
                            type="button"
                            onClick={() => onChange(option.value)}
                            className={`flex-1 flex items-center justify-center py-3 transition-colors duration-150 ${
                                isSelected
                                    ? 'bg-custom-light-blue text-custom-dark'
                                    : 'text-custom-light-grey hover:bg-custom-charcoal/50'
                            }`}
                        >
                            <span className="text-xs font-semibold">{option.label}</span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default GroupByPicker;
